import _Button from "@arco-design/web-react/es/Button";
import _Result from "@arco-design/web-react/es/Result";
var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
import React, { Component } from 'react';
import Feedback from '@src/common/feedback';
var ErrorBoundary = function (_super) {
  __extends(ErrorBoundary, _super);
  function ErrorBoundary() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ErrorBoundary.prototype.render = function () {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        height: '100%'
      }
    }, /*#__PURE__*/React.createElement(_Result, {
      status: "error",
      subTitle: "\u62B1\u6B49\uFF0C\u51FA\u9519\u5566\uFF5E",
      extra: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Button, {
        key: "back",
        type: "primary",
        onClick: function onClick() {
          return location.href = '/themes';
        }
      }, "\u56DE\u5230\u9996\u9875"))
    }), /*#__PURE__*/React.createElement(Feedback, null));
  };
  return ErrorBoundary;
}(Component);
export default ErrorBoundary;